/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Gallery_Desc_Onedrive1Inputs */



/**
* | output |
* | --- |
* | "Sync files from OneDrive and SharePoint." |
*
* @param {Spaces_Gallery_Desc_Onedrive1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const spaces_gallery_desc_onedrive1 = /** @type {((inputs?: Spaces_Gallery_Desc_Onedrive1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Gallery_Desc_Onedrive1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dateien aus OneDrive und SharePoint synchronisieren.")
	return /** @type {LocalizedString} */ ("Sync files from OneDrive and SharePoint.")
});
export { spaces_gallery_desc_onedrive1 as "spaces_gallery_desc_oneDrive" }